/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_BadgeInputs */

const tr_landing_community_mock_badge = /** @type {(inputs: Landing_Community_Mock_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EKİP`)
};

const en_landing_community_mock_badge = /** @type {(inputs: Landing_Community_Mock_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TEAM`)
};

const de_landing_community_mock_badge = /** @type {(inputs: Landing_Community_Mock_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TEAM`)
};

const ru_landing_community_mock_badge = /** @type {(inputs: Landing_Community_Mock_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`КОМАНДА`)
};

/**
* | output |
* | --- |
* | "TEAM" |
*
* @param {Landing_Community_Mock_BadgeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_badge = /** @type {((inputs?: Landing_Community_Mock_BadgeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_BadgeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_badge(inputs)
	if (locale === "de") return de_landing_community_mock_badge(inputs)
	if (locale === "ru") return ru_landing_community_mock_badge(inputs)
	return tr_landing_community_mock_badge(inputs)
});